import { Button, Card, Empty, Flex, Select, Space, Switch, Tag, Typography } from 'antd';

const { Text } = Typography;

const NotificationSettingsMobile = ({ viewModel }) => {
  const {
    loading,
    submitting,
    rows,
    roleOptions,
    userOptions,
    loadData,
    updateRow,
    saveAll,
  } = viewModel;

  return (
    <Space direction='vertical' size={12} style={{ width: '100%' }}>
      <Card>
        <Space direction='vertical' size={8} style={{ width: '100%' }}>
          <Text strong>Cấu hình nhận thông báo</Text>
          <Text type='secondary'>Mỗi loại sự kiện có thể bật/tắt, chọn role fallback và danh sách người nhận ưu tiên.</Text>
          <Flex gap={8} wrap='wrap'>
            <Button onClick={loadData} loading={loading}>Tải lại</Button>
            <Button type='primary' onClick={saveAll} loading={submitting}>Lưu cấu hình</Button>
          </Flex>
        </Space>
      </Card>

      {(rows || []).length === 0 && (
        <Card>
          <Empty description='Không có cấu hình thông báo' image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </Card>
      )}

      {(rows || []).map((row) => (
        <Card key={row.event_type} styles={{ body: { padding: 12 } }}>
          <Space direction='vertical' size={8} style={{ width: '100%' }}>
            <Space direction='vertical' size={2} style={{ width: '100%' }}>
              <Text strong>{row.label}</Text>
              <Text type='secondary'>{row.description}</Text>
              <Tag>{row.event_type}</Tag>
            </Space>

            <Flex justify='space-between' align='center'>
              <Text>Bật thông báo</Text>
              <Switch
                checked={row.enabled}
                onChange={(checked) => updateRow(row.event_type, { enabled: checked })}
              />
            </Flex>

            <Space direction='vertical' size={4} style={{ width: '100%' }}>
              <Text type='secondary'>Nhận theo vai trò (fallback)</Text>
              <Select
                mode='multiple'
                allowClear
                value={row.roles}
                options={roleOptions}
                style={{ width: '100%' }}
                placeholder='Chọn vai trò nhận thông báo'
                onChange={(value) => updateRow(row.event_type, { roles: value || [] })}
              />
            </Space>

            <Space direction='vertical' size={4} style={{ width: '100%' }}>
              <Text type='secondary'>Người nhận cụ thể (ưu tiên)</Text>
              <Select
                mode='multiple'
                allowClear
                value={row.recipient_ids}
                options={userOptions}
                style={{ width: '100%' }}
                placeholder='Nếu chọn, hệ thống sẽ gửi đúng các user này'
                onChange={(value) => updateRow(row.event_type, { recipient_ids: value || [] })}
                optionFilterProp='label'
              />
            </Space>
          </Space>
        </Card>
      ))}
    </Space>
  );
};

export default NotificationSettingsMobile;
